import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const InfoContainer = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.palette.border.dark}`,
  padding: '24px 16px 40px 16px',
  borderRadius: '12px',
  [theme.breakpoints.up('md')]: {
    padding: '36px 32px'
  }
}));

export const CaptionTitle = styled(Text)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    fontSize: '0.8125rem;',
    lineHeight: '1rem'
  }
}));

export const CaptionDescription = styled(Text)(({ theme }) => ({
  ...theme.typography.xl,
  [theme.breakpoints.up('md')]: {
    ...theme.typography.lg
  }
}));
